import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { DsiProductTabDefault as ProductTabDefault } from './ProductTabDefault';
import { ZemplinLoaderWrapper } from '../../..';
import { TableWrapper } from '../../Dsi/General/TableWrapper';
import { ProductTabRowTable } from './ProductTabRowTable';
import { TableRow } from '../../Dsi/General/Table';
import { getProductDefaultInfo } from '../../../utilities/selectors';
import { prop } from '../../../utilities';
import { productHasGift } from '../Cart/utilities';

interface Props {
  apiUrl: string;
  products: any;
  isFetching: boolean;
  addToCart: any;
  addToRequest: any;
  visible?: boolean;
  showSumOfVariants?: boolean;
  hasFavourite?: boolean;
  hasWatchdog?: boolean;
  canOrder?: boolean;
  showMoc?: boolean;
  showWithVat?: boolean;
  loadingPrices?: boolean;
  hasUser?: boolean;
  showStockCount?: boolean;
  isB2b?: boolean;
  isCorporate?: boolean;
  domainId?: number;
  conditionTextMapping?: any;
  user?: any;
  showCompareIcon?: any;
  compareProductIds?: number[];
  addToCompare?: any;
}

function ProductTableList({
  apiUrl,
  products,
  isFetching,
  addToCart,
  addToRequest,
  visible = false,
  showSumOfVariants = false,
  hasFavourite = false,
  hasWatchdog = false,
  canOrder,
  showMoc,
  showWithVat,
  loadingPrices,
  hasUser,
  showStockCount,
  isB2b,
  isCorporate,
  domainId,
  conditionTextMapping,
  user,
  showCompareIcon,
  compareProductIds,
  addToCompare
}: Props) {
  const productsComponent =
    products &&
    products.map((p: any) => {
      const {
        giftSaleData,
        currentSales,
        cartSaleData,
        isBaseType
      } = getProductDefaultInfo(p, apiUrl, showMoc, showWithVat);

      return (
        <StyledTableRow key={`tableList-${p.product_id}`}>
          <ProductTabRowTable
            apiUrl={apiUrl}
            addToCart={addToCart}
            addToRequest={addToRequest}
            product={p}
            showSumOfVariants={showSumOfVariants}
            hasFavourite={hasFavourite}
            hasWatchdog={hasWatchdog}
            canOrder={canOrder}
            showMoc={showMoc}
            showWithVat={showWithVat}
            loadingPrices={loadingPrices}
            hasUser={hasUser}
            showStockCount={showStockCount}
            isB2b={isB2b}
            isCorporate={isCorporate}
            hasGift={
              !!currentSales?.length ||
              productHasGift(giftSaleData, domainId, isB2b, hasUser)
            }
            hasCartSale={productHasGift(cartSaleData, domainId, isB2b, hasUser)}
            conditionTextMapping={conditionTextMapping}
            managerLink={
              user && user.originalUser
                ? `/manager?customerId=${user.outer_id}-${user.id}&customerAddressId=`
                : undefined
            }
            isCompare={compareProductIds && compareProductIds.includes(p.product_id)}
            showCompareIcon={showCompareIcon && !isBaseType}
            addToCompare={addToCompare}
          />
        </StyledTableRow>
      );
    });

  const renderMobileProductTab = (key, product) => {
    const {
      availid,
      availability,
      picture,
      pictureWebP,
      url,
      name,
      publish,
      price,
      oldPrice,
      isNew,
      isSale,
      isFavorite,
      salePercentage,
      id,
      description,
      currency,
      giftSaleData,
      currentSales,
      cartSaleData,
      isBaseType
    } = getProductDefaultInfo(product, apiUrl, showMoc, showWithVat);

    const add = () => {
      return;
    };

    return (
      <StyledTableRow key={`tableList-${product.product_id}`}>
        <ProductTabRowTable
          apiUrl={apiUrl}
          addToCart={addToCart}
          addToRequest={addToRequest}
          product={product}
          showSumOfVariants={showSumOfVariants}
          hasFavourite={hasFavourite}
          hasWatchdog={hasWatchdog}
          canOrder={canOrder}
          hasUser={hasUser}
          showStockCount={showStockCount}
          isB2b={isB2b}
          isCorporate={isCorporate}
          hasGift={
            !!currentSales?.length ||
            productHasGift(giftSaleData, domainId, isB2b, hasUser)
          }
          hasCartSale={productHasGift(cartSaleData, domainId, isB2b, hasUser)}
          conditionTextMapping={conditionTextMapping}
          isCompare={compareProductIds && compareProductIds.includes(id)}
          showCompareIcon={showCompareIcon && !isBaseType}
          addToCompare={addToCompare}
        />
      </StyledTableRow>
    );

    return (
      <ProductTabDefault
        id={id}
        addToFavorite={add}
        addToCompare={add}
        key={key}
        apiUrl={apiUrl}
        picture={picture}
        pictureWebP={pictureWebP}
        price={price}
        oldPrice={oldPrice}
        availid={availid}
        availability={availability}
        url={url}
        name={name}
        description={description}
        addToCart={addToCart}
        addToRequest={addToRequest}
        isNew={isNew}
        isSale={isSale}
        isFavorite={isFavorite}
        salePercentage={salePercentage}
        currency={currency}
        // addToFavorite={addToFavorite}
      />
    );
  };

  const mobileProductsComponent =
    products && products.map((p: any, key) => renderMobileProductTab(key, p));

  return (
    <ProductsCardWrapper visible={visible}>
      {isFetching ? (
        <ZemplinLoaderWrapper height={500} />
      ) : (
        <>
          <DesktopListProductsWrapper>
            <TableWrapper
              noItemsText={__('Nenašli sa žiadne produkty')}
              rows={productsComponent}
            />
          </DesktopListProductsWrapper>
          <MobileListProductsWrapper>
            {mobileProductsComponent}
          </MobileListProductsWrapper>
        </>
      )}
    </ProductsCardWrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const ProductsCardWrapper = styled(FlexRow)<{ visible: boolean }>`
  flex-flow: row wrap;
  margin-bottom: ${({ visible }) => (visible ? rem(24) : 0)};
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  animation: ${animateIn} 0.2s ease;

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${({ visible }) => (visible ? rem(32) : 0)};
  `};
`;

const DesktopListProductsWrapper = styled.div`
  display: block;
  width: 100%;

  ${({ theme }) => theme.mediab.m580`
    display: none;
`}
`;

const MobileListProductsWrapper = styled.div`
  display: none;
  width: 100%;

  ${({ theme }) => theme.mediab.m580`
      display: inline-block;
  `}
`;

const StyledTableRow = styled(TableRow)`
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${rem(16)};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  margin-bottom: ${rem(8)};
`;

export { ProductTableList as DsiProductTableList };
